import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "antd/dist/reset.css";
import App from "./App";
import AppProviders from "./components/AppProviders";
import reportWebVitals from "./reportWebVitals";
import { setUnauthorizedHandler } from "./services/salesforceApi";
import { isSessionError } from "./utils/sessionErrorUtils";
import { storage } from "./auth/storage";
import { clearPersistedData } from "./utils/clearPersistedData";
// Expose React globals for child ESM externals
try {
  // React runtime globals
  window.React = React;
  // CRA uses the new root API; also expose classic API if needed
  window.ReactDOM = require("react-dom");
  // JSX runtime is resolved by bundlers; expose a placeholder so externals bind
  window.ReactJSXRuntime = require("react/jsx-runtime");
  // Expose antd for child ESM externals
  window.antd = require("antd");
  // Expose react-router-dom so ESM components can access Router APIs
  window.ReactRouterDOM = require("react-router-dom");
} catch (e) {}

// Function to set the global session error handler
window.setGlobalSessionErrorHandler = (_) => {};

// Expose utility to clear persisted Redux data
window.clearPersistedData = clearPersistedData;

// Global unhandled promise rejection handler for session errors
window.addEventListener("unhandledrejection", (event) => {
  const error = event.reason;
  if (!isSessionError(error)) return;

  // Prevent the default unhandled rejection behavior (avoid red console errors)
  try {
    event.preventDefault();
  } catch (_) {}

  // Clear any stored app auth session to keep UI consistent
  try {
    storage.clearAuthSession();
  } catch (_) {}

  // Avoid immediate silent reattempts
  try {
    window.sessionStorage.setItem("SF_DISABLE_SILENT_ONCE", "1");
  } catch (_) {}

  // Redirect to login with explicit message
  const target = "/login?error=session_expired";
  try {
    window.location.replace(target);
  } catch (_) {
    window.location.assign(target);
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
// Set a default unauthorized handler for Salesforce client
try {
  setUnauthorizedHandler((err) => {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("Unauthorized (401) detected; redirecting to login.", err);
    }

    // Best-effort: clear any stored app auth session to avoid UI showing as logged-in
    try {
      storage.clearAuthSession();
    } catch (_) {}

    // Avoid immediate silent SSO re-attempts on next mount
    try {
      window.sessionStorage.setItem("SF_DISABLE_SILENT_ONCE", "1");
    } catch (_) {}

    // Prefer redirecting to a dedicated login page with an explicit message
    const target = "/login?error=session_expired";
    try {
      // Use replace to avoid back button returning to a broken state
      window.location.replace(target);
    } catch (_) {
      window.location.assign(target);
    }
  });
} catch (_) {}
root.render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>,
);

// Basic web-vitals reporter (no-op by default)
reportWebVitals((metric) => {
  if (window && window.__VITALS_REPORT__) {
    try {
      window.__VITALS_REPORT__(metric);
    } catch (_) {}
  }
});
